import React from "react";
import FeedHistory from "../feedHistory/FeedHistory";
import FeedAssign from "./FeedAssign";
import CustomFields from "./CustomFields";

const FEED_ASSIGN_EVENTS = new Set([
  "change_status",
  "change_board",
  "card_assign",
]);

const FEED_HISTORY_EVENTS = new Set([
  "create_card",
  "description_update",
  "allocated_hours_update",
  "priority_update",
  "card_log_move_from_card",
  "attachment_added",
  "attachment_deleted",
  "label_added",
  "label_removed",
  "parent_task_relationship_removed",
  "collaborator_added",
  "collaborator_removed",
  "parent_card_update",
  "card_log_updated",
  "card_log_deleted",
  "card_log_move",
]);

const ListFeedCard = ({ card, boardName }) => {
  const eventType = card?.response_object?.event_type;

  if (!card || !eventType) {
    return null;
  }

  if (eventType === "custom_field_update") {
    return <CustomFields history={card} boardName={boardName} />;
  }

  if (eventType === "due_date_update") {
    return <FeedHistory history={card} boardName={boardName} isDueDate={true} />;
  }

  if (eventType === "parent_task_relationship") {
    return <FeedHistory history={card} boardName={boardName} hideDetails={true} />;
  }

  if (FEED_ASSIGN_EVENTS.has(eventType)) {
    return <FeedAssign history={card} boardName={boardName} />;
  }

  if (FEED_HISTORY_EVENTS.has(eventType)) {
    return <FeedHistory history={card} boardName={boardName} />;
  }

  return (
    null
  );
};

export default ListFeedCard;
